import { Component, OnInit, Input } from '@angular/core';
import { capitalize } from '@utils/string-utils';
@Component({
  selector: 'display-delivery-time',
  styles: ['.font12 { font-size: 12px; padding: 0 2px;}'],
  template: `
    <pdq-button [plain]="true" (onClick)="showDisplayTimes = !showDisplayTimes">{{
      showDisplayTimes ? 'Hide delivery time' : 'Show delivery time'
    }}</pdq-button>
    @if (showDisplayTimes) {
      <div class="col gap font12">
        @if (displayMethodsAllWeek) {
          <div>Show 24/7</div>
        } @else {
          @for (day of deliveryDaysNTimes; track day) {
            <div>
              @if (day.enabled) {
                <div>{{ day.day }}, {{ day.from }} to {{ day.to }}</div>
              }
            </div>
          }
        }
      </div>
    }
  `,
  standalone: false,
})
export class DisplayDeliveryDaysNTimesComponent implements OnInit {
  @Input() shipping;
  deliveryDaysNTimes: any = {};
  displayMethodsAllWeek = false;
  showDisplayTimes = false;
  constructor() {}

  ngOnInit() {
    const { deliveryDaysAllWeek, deliveryDaysAndTimes } = this.shipping;
    this.displayMethodsAllWeek = deliveryDaysAllWeek;
    this.deliveryDaysNTimes = deliveryDaysAndTimes?.map((d) => {
      return {
        day: capitalize(d.day),
        enabled: d.enable,
        from: d.fromTime,
        to: d.toTime,
      };
    });
  }
}
